var plugin_rtlignore_default = {
  "alignLeft": "HZPzk",
  "textWrapNowrap": "JhmEF",
  "alignRight": "n0Us-",
  "alignCenter": "UMrP3",
  "sizeFullWidth": "zVyMO",
  "renderedInTable": "kKtpe",
  "sizeOriginal": "XJsMK",
  "sizeContent": "PH6ON",
  "sizeSmall": "Otnkc",
  "sizeSmallCenter": "FESus",
  "flex": "b08qR",
  "atomic": "Hub1I",
  "embed": "xex-E",
  "horizontalScrollbar": "SGvxV",
  "pluginContainerMobile": "o2wOo"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
